import type { ComponentPropsWithRef, ReactNode } from "react";
import { forwardRef } from "react";
import { BlockSection } from "@/react/components/shared/BuilderUI/BlockSection";
import { useTopBlockStyles } from "../../../Hooks/useTopBlockStyles";
import type { StyleValue } from "../../../StyleValue.types";
import { salesPrimaryBlockDefaultStyles } from "../constants";

export interface SalesBlock3Props extends ComponentPropsWithRef<"div"> {
  badges?: ReactNode;
  description?: ReactNode;
  header?: ReactNode;
  leftContent?: ReactNode;
  styles?: Record<string, StyleValue>;
  user?: ReactNode;
}

export const SalesBlock3 = forwardRef<HTMLDivElement, SalesBlock3Props>(
  (
    {
      leftContent,
      header,
      user,
      description,
      badges,
      className,
      styles,
      ...rest
    },
    ref,
  ) => {
    const { backgroundStyles, paddingStyles, marginStyles } = useTopBlockStyles(
      {
        styles,
        defaultStyles: salesPrimaryBlockDefaultStyles,
      },
    );

    return (
      <BlockSection ref={ref} className={className} {...rest}>
        <BlockSection.Background style={backgroundStyles}>
          <BlockSection.Container>
            <BlockSection.Content
              style={{
                ...paddingStyles,
                ...marginStyles,
              }}
            >
              <div className="wb-flex wb-flex-col wb-gap-10 md:wb-grid md:wb-grid-cols-2 md:wb-gap-16">
                <div className="wb-mx-auto">{leftContent}</div>
                <div className="wb-flex wb-flex-col wb-gap-4 md:wb-gap-8">
                  {header}
                  <div>{user}</div>
                  {description}
                  {badges}
                </div>
              </div>
            </BlockSection.Content>
          </BlockSection.Container>
        </BlockSection.Background>
      </BlockSection>
    );
  },
);

SalesBlock3.displayName = "SalesBlock3";
